import React from "react";
import styles from "./styles/Paragraph.module.css";

export default function Paragraph(props) {
  return (
    <p style={props.style} className={`${styles.defaults} ${props.center && styles.center} ${props.size == 'small' && styles.small} ${props.size == 'big' && styles.big} ${props.className}`}>{props.children}</p>
  );
}
